import React from "react";
import { ThemeProvider } from "styled-components";
import { Box, Flex } from "rebass";

import { PrimaryButton, H2, H3, Input, PageSection } from "components";

import invertTheme from "../../invertTheme";

export class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      location: "",
    };
  }

  componentDidMount() {
    this.setState({ location: window.location.href });
  }

  submitForm = (e) => {
    e.preventDefault();
    const form = document.getElementById("form");
    const data = new FormData(form);
    fetch(
      "https://script.google.com/macros/s/AKfycby3m9uGtQqoBH1riLi_pz3VxvAS_m-zkrR_syIvSlQlbqOJ4izqOLg94Ya4_ZccDA4v/exec",
      {
        method: "POST",
        body: data,
      }
    );
    this.setState({ submitted: true });
  };

  render() {
    return (
      <PageSection column="true" borderTop="true">
        <Box width={1 / 1} bg="violet" py={[6, 7, 8]} px={[6, 7, 8]}>
          {this.props.primary.title && this.props.primary.title[0] && (
            <H2 mb={4} color="white">
              {this.props.primary.title[0].text}
            </H2>
          )}
          {!this.state.submitted && (
            <form
              id="form"
              method="POST"
              action="https://script.google.com/macros/s/AKfycby3m9uGtQqoBH1riLi_pz3VxvAS_m-zkrR_syIvSlQlbqOJ4izqOLg94Ya4_ZccDA4v/exec"
              onSubmit={this.submitForm}
            >
              <Flex flexDirection={["column", null, "row"]} mb={2}>
                <Box
                  mr={[0, null, 1]}
                  width={[1 / 1, null, 1 / 2]}
                  mb={[2, null, 0]}
                >
                  <Input name="Name" type="text" placeholder="Name" required />
                </Box>
                <Box ml={[0, null, 1]} width={[1 / 1, null, 1 / 2]}>
                  <Input
                    name="Email"
                    type="email"
                    placeholder="Email"
                    required
                  />
                </Box>
              </Flex>
              <Input
                name="Organization"
                type="text"
                placeholder="Organization you represent"
                required
              />
              <input
                name="URL"
                type="text"
                value={this.state.location}
                hidden
              />
              <ThemeProvider theme={invertTheme}>
                <Box mt={2}>
                  <PrimaryButton>Sign Up</PrimaryButton>
                </Box>
              </ThemeProvider>
            </form>
          )}
          {this.state.submitted && (
            <H3 color="white">
              Thanks for submitting your support! We'll keep you updated on the
              campaign.
            </H3>
          )}
        </Box>
      </PageSection>
    );
  }
}



// WEBPACK FOOTER //
// ./src/slices/Form/Form.js